import { Component, EventEmitter, forwardRef, HostListener, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { SelectorItem } from 'src/app/model';

const noop = () => {
  // blank
};

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSelectComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CustomSelectComponent),
      multi: true
    }
  ]
})
export class CustomSelectComponent implements ControlValueAccessor, Validator {
  @ViewChild('selectorElement') selectorElement;
  @Input() placeholder: string = "Placeholder";
  @Input() innerValue: string;
  @Input() values: Array<SelectorItem>;
  @Input() required: boolean = true;
  @Input() disabled: boolean = false;
  @Input() size: string;
  @Input() hideOption: boolean;
  @Input() isToolTip: boolean = false;
  @Input() classes: string = '';
  @Output() valueSelected = new EventEmitter<string>();

  private onTouchedCallback: () => void = noop;
  private onValidateCallback = (_: any) => {
    // blank
  };
  private onChangeCallback: (_: any) => void = noop;

  isActive: boolean = false;
  selIndex: number = null;

  get value(): string {
    return this.innerValue;
  }

  set value(v: string) {
    this.innerValue = v;
    this.onChangeCallback(v);
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  registerOnValidatorChange(fn: any): void {
    this.onValidateCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: string): void {
    this.innerValue = obj;
  }

  getDisplayValue(value: string): string {
    if(this.values){
      for(let v of this.values)
        if(v.value === value)
          return v.key;
    }
  }

  selectItem(item: SelectorItem): void {
    this.writeValue(item.value);
    this.onValidateCallback(item.value);
    this.onChangeCallback(item.value);
    this.valueSelected.emit(item.value);
  }

  toggleActive(): void {
    if(!this.disabled)
      this.isActive = !this.isActive;
  }

  @HostListener('document:click', ['$event.target'])
  clickedOutside(targetElement){
    const clickedInside = this.selectorElement?.nativeElement?.contains(targetElement);
    if (!clickedInside) {
      this.isActive = false;
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return (this.innerValue) ? null : {
      required: {
        valid: false
      },
    };
  }

  tabPress(event: any): void {
    if(this.isActive){
      if(this.selIndex !== null){
        if(this.values[this.selIndex])
          this.selectItem(this.values[this.selIndex]);
      }else this.selectItem(this.values[0]);

      this.isActive = false;
    }
  }

  /**
   * @Deprecated have issues in IE
   * */
  focusGained(event: any): void {
    // blank
  }

  /**
   * @Deprecated have issues in IE
   * this one especially
   * */
  focusLost(event: any): void {
    // blank
  }

  arrowUp(event: any): void {
    event.preventDefault();

    if(this.values){
      if(this.values.length > 0){
        if(!this.isActive)
          this.isActive = true;

        if(this.selIndex === null || this.selIndex === 0){
          this.selIndex = 0;
          this.values[0].isOver = true;
          return;
        }else{
          if(this.selIndex > 0){
            this.selIndex--;
            for(let i = 0; i < this.values.length; i++){
              this.values[i].isOver = this.selIndex === i;
            }
          }
        }
      }
    }
  }

  arrowDown(event: any): void {
    event.preventDefault();

    if(this.values){
      if(this.values.length > 0){
        if(!this.isActive)
          this.isActive = true;

        if(this.selIndex === null){
          this.selIndex = 0;
          this.values[0].isOver = true;
          return;
        }else{
          if(this.selIndex < (this.values.length-1)){
            this.selIndex++;
            for(let i = 0; i < this.values.length; i++){
              this.values[i].isOver = this.selIndex === i;
            }
          }
        }
      }
    }
  }

  enterPressed(event: any): void {
    event.preventDefault();

    if(!this.isActive)
      this.isActive = true;

    if(this.selIndex !== null && this.values){
      if(this.values[this.selIndex]){
        this.selectItem(this.values[this.selIndex]);
        this.isActive = false;
      }
    }
  }


}
